import { Button } from '@mui/material';
var AccurityButton = Button;
export default AccurityButton;
//# sourceMappingURL=AccurityButton.js.map